<script setup>
// Instagram Reauthorize.vue
import { ref } from 'vue';
import InboxReconnectionRequired from '../../components/InboxReconnectionRequired.vue';

import instagramClient from 'dashboard/api/channel/instagramClient';

import { useI18n } from 'vue-i18n';
import { toast } from 'dashboard/helper/toast';
import { metaAuthErrorMessage } from 'dashboard/helper/metaAuthError';

const { t } = useI18n();

const isRequestingAuthorization = ref(false);

async function requestAuthorization() {
  try {
    isRequestingAuthorization.value = true;
    const response = await instagramClient.createAuthorization();

    const {
      data: { url },
    } = response;

    window.location.href = url;
  } catch (error) {
    toast.error(metaAuthErrorMessage(error, t, 'INBOX_MGMT.ADD.INSTAGRAM'));
  } finally {
    isRequestingAuthorization.value = false;
  }
}
</script>

<template>
  <InboxReconnectionRequired
    class="mx-8 mt-5"
    @reauthorize="requestAuthorization"
  />
</template>
